// extracted by mini-css-extract-plugin
module.exports = {"Title":"SpotifyEmbed_Title__ra7O3"};